<!--
 * @Description: 页面级详情组件
 * @Author: cxh
 * @Date: 2022-09-16 11:25:08
 * @LastEditTime: 2023-03-09 10:35:38
 * @LastEditors: cxh
-->
<template>
  <div :class="{ 'cos-view-content': view, 'cos-no-header': !header }">
    <slot name="header">
      <div class="cos-view-content-header" v-if="header">
        <div class="flex">
        <h1>{{ title }}</h1>
          <favorite-icon type="add" is-detail="true" v-if="collectionId===null"  @click="addFav"/>
          <favorite-icon type="cancel" is-detail="true" v-else  @click="cancelFav"/>
        </div>
        <div class="flex">
          <div class="cos-view-content-header-list">
            <span class="cos-view-content-header-label">{{ t('custom.followBy') }}</span>
            <span class="cos-view-content-header-name">{{ sellerName || '--' }}</span>
          </div>
          <div class="cos-view-content-header-list">
            <span class="cos-view-content-header-label">{{ customLabel }}</span>
            <span class="cos-view-content-header-name">{{ customValue || '--' }}</span>
          </div>
          <div class="header-list" v-if="turnedContract || turnedPotential || turnedTransaction">
            <span class="cos-view-content-header-label">历史最高客户阶段</span>
            <span class="cos-view-content-header-name">{{
                turnedTransaction ? `成交客户(${turnedTransaction})` : (turnedContract ? `签约客户(${turnedContract})` : (turnedPotential ? `潜在客户(${turnedPotential})` : '--'))
              }}</span>
          </div>
        </div>
        <div class="cos-view-content-header-line"></div>
      </div>
    </slot>
    <slot></slot>
  </div>
</template>
<script lang="ts" setup name="MoreButton">
import { useI18n } from 'vue-i18n'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
const { t } = useI18n()
defineProps({
  sellerName: String,
  title: String,
  collectionId: String,
  header: Boolean,
  customLabel: String,
  customValue: String,
  turnedContract: String, // 转签约客户时间
  turnedPotential: String, // 转潜在客户时间
  turnedTransaction: String, // 转成交时间
  addFav: Function,
  cancelFav: Function,
  view: {
    type: Boolean,
    default: true
  }
})
</script>
<style lang="scss" scoped>
.cos-no-header {
  :deep(.ant-tabs) {
    margin-top: -20px;
  }
}
.cos-view-content-header {
  h1 {
    font-weight: 600;
    font-size: 18px;
    color: #333;
    margin-top: 4px;
    margin-bottom: 13px;
  }
  &-list {
    margin-right: 76px;
  }
  &-label {
    color: #9fa9ba;
    margin-right: 16px;
  }
  &-name {
    color: #333333;
  }
  &-line {
    border: 1px dashed #eff2f4;
    margin-top: 8px;
  }
  &-fav {
    padding-bottom: 15px;
  }
}
</style>
